<div class="invite-card">
  <div class="gold-line top left first"></div>
  <div class="gold-line top left second"></div>
  <div class="gold-line bottom right first"></div>
  <div class="gold-line bottom right second"></div>
  <div
    class="cover-overlay"
    [class.cover-image]="coverImageUrl"
    [ngStyle]="
      coverImageUrl ? { 'background-image': 'url(' + coverImageUrl + ')' } : {}
    "
  >
    <div [class.gradient-overlay]="coverImageUrl">
      <div *ngIf="detailsLoaded" class="invite-content">
        <div class="names-container">
          <div class="d-block" *ngIf="tenantType == 'wedding'">
            {{ couples[0] }} <span style="font-size: 1.3rem">weds</span>
            {{ couples[1] }}
          </div>
          <div class="d-block" *ngIf="tenantType != 'wedding'">
            <span class="d-md-inline d-block">{{ eventTitle }} </span>
            <span *ngIf="tenantType == 'housewarming'" class="d-md-inline d-block">House Warming</span>
          </div>
        </div>
        <!-- <p class="subtext mb-0">Invite you to their wedding ceremony</p> -->
        <hr class="gold-line-divider m-0 mb-2" />
        <p class="date-time mb-1" *ngIf="eventCount > 1 &&(eventDate || eventLocation)">
          <span class="script">
            <span *ngIf="eventDate"
              >{{ eventDateExtract
              }}<sup>{{ eventDateExtractSuffix }}</sup></span
            >
            <span *ngIf="eventDate"> {{ eventMonth }}</span>
            <span *ngIf="eventTime">
              &#64; {{ eventTime }} {{ eventTimeSuffix }}</span
            >
            <span class="d-none d-md-inline" *ngIf="eventDate && eventLocation"
              >&nbsp; | &nbsp;</span
            >
            <span class="d-md-inline d-block" *ngIf="eventLocation">{{
              eventLocation
            }}</span>
          </span>
        </p>
        <div
          class="d-inline-flex gap-2 me-2 align-content-center justify-content-center my-1"
        >
          <a
            (click)="onRsvpClick()"
            id="btnSaveEvent"
            class="d-inline-flex k-btn t-border-gradient-primary py-1 text-decoration-none mb-0 cursor-pointer"
          >
            <span
              class="gradient-text-gold d-inline-flex gap-2 mx-2 k-fs-medium"
            >
              <span>Confirm Your Presence</span>
            </span>
          </a>
          <a
            [routerLink]="
              tenantService.getTenantPrefixedPath('event/invitation')
            "
            id="viewInvite"
            class="d-inline-flex k-btn t-gray-gradient text-decoration-none text-center"
          >
            <span
              class="gradient-text-gold d-inline-flex gap-2 mx-2 k-fs-medium"
            >
              <span>View Invite</span>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
